import { render, staticRenderFns } from "./TaskIcon.vue?vue&type=template&id=17df02da&scoped=true"
import script from "./TaskIcon.vue?vue&type=script&lang=js"
export * from "./TaskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df02da",
  null
  
)

export default component.exports